import { useMemo } from "react";
import { Label, RadioButton, TextStyle } from "@lannister/duplo";

import { ReactComponent as CardIcon } from "../../assets/icons/card.svg";
import { ReactComponent as EmptyWallet } from "../../assets/icons/empty-wallet.svg";
import { ReactComponent as ApplePay } from "../../assets/images/ApplePay.svg";

import { PaymentMethodType } from '../../common/constants';
import Wallet from './wallet';
import CardDetailsForm from './cardDetailsForm';

export const PaymentMethodOptions = ({
    isCardEnabled,
    isWalletEnabled,
    isApplePayEnabled,
    isSaveCardOptionEnabled,
    handleChange,
    onChangePaymentMethod
}) => {
    const options = useMemo(() => {
        const opts = [];
        if (isApplePayEnabled) {
            opts.push({
                label: "Apple Pay",
                value: PaymentMethodType.ApplePay,
                icon: <ApplePay />
            });
        }

        if (isCardEnabled) {
            opts.push({
                label: "Debit or Credit Card",
                value: PaymentMethodType.BankCard,
                icon: <CardIcon />,
                content: () => <CardDetailsForm handleChange={handleChange} isSaveCardOptionEnabled={isSaveCardOptionEnabled} />
            });
        }
        if (isWalletEnabled) {
            opts.push({
                label: "Digital Wallet",
                value: PaymentMethodType.Wallet,
                icon: <EmptyWallet />,
                content: () => <Wallet handleChange={handleChange} />
            });
        }
        return opts;
    }, [isCardEnabled, isWalletEnabled, isApplePayEnabled, handleChange, isSaveCardOptionEnabled]);

    return (
        <div>
            <Label labelText="Choose your payment method" textStyle={TextStyle.Heading5Semibold} wrap={true}/>
                <RadioButton
                    options={options}
                    defaultValue={isApplePayEnabled ? PaymentMethodType.ApplePay : PaymentMethodType.BankCard}
                    onChange={onChangePaymentMethod}
                />
        </div>
    );
}
